import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";
import { createGenerateReportHandler } from "../reports/sagas";

import { reportGeneratorTaskCreateRequest, tableFetchError, tableFetchRequest, tableFetchSuccess } from "./actions";
import { RoutesActionTypes } from "./types";

export function* handleRoutesTableFetch(action: ReturnType<typeof tableFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const res = yield call(callGet, "/routes/", action.payload, source.token);
    yield put(tableFetchSuccess(res.data));
  } catch (err) {
    yield put(tableFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

const handleRoutesReportFetch = createGenerateReportHandler<ReturnType<typeof reportGeneratorTaskCreateRequest>>(
  "/routes/report/"
);

function* watchRoutesSagas(): SagaIterator {
  yield takeLatest(RoutesActionTypes.TABLE_FETCH_REQUEST, handleRoutesTableFetch);
  yield takeLatest(RoutesActionTypes.GENERATE_REPORT_REQUEST, handleRoutesReportFetch);
}

export default watchRoutesSagas;
